import React from 'react';
import { Box } from '@mui/material';
import BroadcastForm from '../../../../components/reusables/forms/BroadcastForm';

export default function Ebroadcast() {
    return (
        <Box>
            <BroadcastForm />
        </Box>
    );
}
